<template>
  <a-cascader @change="changeXzc" :expandTrigger="expandTrigger" :allowClear="false" :disabled="disabled" :value="getValueSting" :changeOnSelect="changeOnSelect" :options="options" :placeholder="placeholder" />
</template>
<script>
import { getAction } from '@/api/manage'

export default {
  name: 'OrgSelect',
  props: {
    value: String,
    //是否只查当前用户权限内的行政组织
    userXzzz:{
      type:Boolean,
      default:true
    },
    placeholder: String,
    changeOnSelect:{
      type:Boolean,
      default:false
    },
    orgType:{
      type:String,
      default:''
    },
    category:{
      type:String,
      default:''
    },
    expandTrigger:{
      type:String,
      default:'click'
    },
    getPopupContainer:{
      type: Function,
      default: (node) => node.parentNode
    },
    disabled:{
      type:Boolean,
      default:false
    },
    esleDepart:{
      type:Boolean,
      default:false
    },
  },

  data() {
    return {
      options: [],
      defaultValue:[]
    };
  },
  created() {
    this.$nextTick(() => {
      this.initAreaData();
    })
  },
  computed: {
      getValueSting(){
        // update-begin author:wangshuai date:20200601 for: 不显示placeholder的文字 ------
        // 当有null或“” placeholder不显示
        if(this.value != null){
          var defaultValueThis = [];
          if(this.options.length>0){
            // for(var i=0;i<=(this.value.length-this.options[0].orgCode.length)/3;i++){
            //   defaultValueThis.push(this.value.substr(0,this.options[0].orgCode.length+(i)*3));
            // }
            for(var q=0;q<this.options.length;q++){
              if(this.value.indexOf(this.options[q].value)==0){
                for(var i=0;i<=(this.value.length-(this.options[q].value.length))/3;i++){
                  if(i==0){
                    defaultValueThis.push(this.options[q].value);
                  }else{
                    defaultValueThis.push(this.options[q].value+""+this.value.substr(this.options[q].value.length,3*i));
                  }
                }
              }
            }
            
          }
          return defaultValueThis;
        }else{
          return undefined;
        }
        // update-end author:wangshuai date:20200601 for: 不显示placeholder的文字 ------
      },
  },
  methods: {
    changeXzc(value,b) {
      var val='';
      var obj = {};
      if(value.length>0){
        val=value[value.length-1];
        obj = b[b.length-1];
      }
      if(this.expandTrigger=='hover'){
        this.defaultValue = val;
      }
      this.value = val;
      this.$emit('input', val);
      this.$emit('change', val);
      this.$emit('ok', obj);
    },
    initAreaData(){
      this.options = [];
      let that = this;
      getAction('/sys/sysDepart/queryTreeList/by/orgType?orgType='+this.orgType+"&userXzzz="+this.userXzzz+"&category="+this.category,{}).then((res)=>{
        let orgList = res.result;
        if(that.esleDepart){
          orgList.push(
            {
              title:"其他",
              value:"A02",
              label:"其他",
              key:'A02',
              orgCode:'A02',
              isLeaf: false,
              leaf:false,
              children:[
                {
                  title:"其他",
                  label:"其他",
                  key:'A02A01',
                  value:"A02A01",
                  orgCode:'A02A01',
                  isLeaf: false,
                  leaf:false,
                  children:[
                    {
                      title:"其他",
                      value:"A02A01A01",
                      label:"其他",
                      key:'A02A01A01',
                      orgCode:'A02A01A01',
                      children:null,
                      isLeaf: true,
                      leaf:true
                    }
                  ]
                }
              ]
            }
          )
        }
        orgList = this.getChildrenList(orgList);
        this.options = orgList;
      })
    },
    //递归组装数据
    getChildrenList(orgList){
      for(var i = 0;i<orgList.length;i++){
        orgList[i].value = orgList[i].orgCode;
        orgList[i].label = orgList[i].title;
        if(orgList[i].children != null){
          orgList[i].children = this.getChildrenList(orgList[i].children);
        }
      }
      return orgList;
    }
  },
};
</script>